class MainProductSelector extends ProductSelector {
  constructor() {
    super();
  }

  /**
   * On variant change.
   *
   * @param {Object} event
   * @returns {Void}
   */
  onVariantChange(event) {
    super.onVariantChange(event);
    if (event.target.type === 'number') {
      return;
    }

    this.updateOptionLabels();

    if (!this.currentVariant) {
      return;
    }

    this.updateMedia();
    this.updateURL();
    this.updatePickupAvailability();

    document.dispatchEvent(
      new CustomEvent('sku:update', {
        detail: { sku: this.currentVariant.sku },
      }),
    );
  }

  /**
   * Update the selected value shown in each option label.
   *
   * @returns {Void}
   */
  updateOptionLabels() {
    this.querySelectorAll('[js-current-value]').forEach((el) => {
      const fieldset = el.closest('fieldset');
      if (!fieldset) return;

      const selected =
        fieldset.querySelector('input[type="radio"]:checked') ||
        fieldset.querySelector('select');

      if (selected) el.textContent = selected.value;
    });
  }

  /**
   * Re-fetch and replace the pickup availability block for the current variant.
   *
   * @returns {Void}
   */
  updatePickupAvailability() {
    const sectionId = this.dataset.sectionId;
    const containerId = `Product-Pickup-availability-${sectionId}`;
    const container = document.getElementById(containerId);
    if (!container) return;

    const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const newContainer = new DOMParser()
          .parseFromString(text, 'text/html')
          .getElementById(containerId);

        if (newContainer) container.replaceWith(newContainer);
      })
      .catch((error) => console.log(error));
  }

  /**
   * Update media.
   *
   * @returns {Void}
   */
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    // const productMedia = document.querySelector('product-media');
    // productMedia.setActiveMedia(this.currentVariant.featured_media.id);
  }

  /**
   * Update URL.
   *
   * @returns {Void}
   */
  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`,
    );
  }
}

customElements.define('main-product-selector', MainProductSelector);
